import api from './client';

export type SeveridadeNotif = 'critico' | 'alerta' | 'info';

/** Notificação in-app (espelha o DTO de NotificacoesController/NotificacaoService). */
export interface Notificacao {
  id: number;
  criadoEm: string;
  tipo: string;
  severidade: SeveridadeNotif;
  titulo: string;
  corpo?: string | null;
  link?: string | null;
  lida: boolean;
}

export interface NotificacoesResposta {
  itens: Notificacao[];
  /** Total de não-lidas visíveis ao usuário (independe do `top`) — alimenta o badge. */
  naoLidas: number;
}

/** Categoria de uma notificação = prefixo do `tipo` antes do ponto (ex.: "cte.baixado" → "cte"). */
export const categoriaDoTipo = (tipo: string): string => tipo.split('.')[0];

/**
 * Categorias que o usuário pode silenciar em /config (rótulos só no front — o
 * backend filtra genericamente por prefixo, então não há catálogo espelhado).
 */
export const CATEGORIAS_NOTIFICACAO: { prefixo: string; label: string; descricao: string }[] = [
  { prefixo: 'cotacao',   label: 'Cotações',             descricao: 'Fornecedor respondeu uma cotação; pedidos gerados a partir dela.' },
  { prefixo: 'pedido',    label: 'Pedidos de compra',    descricao: 'Pedido de compra criado.' },
  { prefixo: 'sugestao',  label: 'Sugestões',            descricao: 'Pedidos gerados a partir de uma sugestão salva.' },
  { prefixo: 'reposicao', label: 'Recálculo da Reposição', descricao: 'Painel 360 atualizado ou falhou ao atualizar.' },
  { prefixo: 'estoque',   label: 'Resumo da Reposição',  descricao: 'Resumo diário: itens acabando, abaixo do mínimo, dead stock, metas.' },
  { prefixo: 'cte',       label: 'CT-e e certificados',  descricao: 'CT-e novos baixados da SEFAZ e avisos de certificado vencendo.' },
  { prefixo: 'nfe',       label: 'NF-e de terceiros',    descricao: 'NF-e novas recebidas.' },
];

export const notificacoesApi = {
  listar: async (apenasNaoLidas = false, top = 30): Promise<NotificacoesResposta> => {
    const r = await api.get<NotificacoesResposta>('/notificacoes', {
      params: { apenasNaoLidas, top },
    });
    return r.data;
  },
  marcarLida: async (id: number): Promise<void> => {
    await api.post(`/notificacoes/${id}/lida`);
  },
  marcarTodasLidas: async (): Promise<void> => {
    await api.post('/notificacoes/marcar-todas-lidas');
  },
  /** "Limpar" — remove do feed deste usuário (não apaga a linha compartilhada). */
  dispensar: async (id: number): Promise<void> => {
    await api.post(`/notificacoes/${id}/dispensar`);
  },
  dispensarTodas: async (): Promise<void> => {
    await api.post('/notificacoes/dispensar-todas');
  },
};
